import axios from "axios";

export const platformClient = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/platform`,
    withCredentials: true,
});

export const MODULES = [
    { id: "production", label: "Productiedata", desc: "Orders, machinecapaciteit en voortgang in één overzicht." },
    { id: "crm", label: "CRM", desc: "Klanten, leads en opvolging die zichzelf bijhoudt." },
    { id: "planning", label: "Personeelsplanning", desc: "Roosters die zichzelf opstellen." },
    { id: "invoicing", label: "Facturatie", desc: "Van offerte tot factuur, automatisch." },
];

export const PASSWORD_POLICY_MSG = "Minimaal 10 tekens, met minstens 1 hoofdletter, 1 kleine letter en 1 cijfer.";

export function isPasswordStrong(pw) {
    return pw.length >= 10 && /[a-z]/.test(pw) && /[A-Z]/.test(pw) && /[0-9]/.test(pw);
}

export function formatPlatformError(detail) {
    if (detail == null) return "Er ging iets mis. Probeer het opnieuw.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
